import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { TenantEnvironment } from "../models/tenant";
import { DataService } from "../../core/data.service";
import { ODataResponse } from '../models/odata-response';
import { switchMap } from 'rxjs/internal/operators/switchMap';
import { of } from 'rxjs';
import { AppConfigService } from 'src/app/core/app-config.service';

@Injectable({
  providedIn: "root",
})
export class TenantEnvironmentDataService extends DataService<
  TenantEnvironment
> {
  constructor(http: HttpClient, acs: AppConfigService) {
    super(http, "TenantEnvironments", acs);
  }

  linkCount(
    tenantId: number,
  ) {
    let url = `${this.acs.current.configApiUrl}odata/TenantEnvironments?$filter=TenantId eq ${tenantId}&$count=true&$top=0`;
    return this.http.get<ODataResponse<TenantEnvironment>>(url);
  } 
  
  linkExists(
    tenantId: number,
    environmentId: number
  ) {
    let url = `${this.acs.current.configApiUrl}odata/TenantEnvironments?$filter=TenantId eq ${tenantId} and EnvironmentId eq ${environmentId}&$count=true&$top=0`;
    return this.http.get<ODataResponse<TenantEnvironment>>(url).pipe(
      switchMap((r) => {
        let exists = +r['@odata.count'] > 0;
        return of(exists);
      })
    );
  }   
}
